
import { computed, defineComponent, onMounted } from 'vue'
import { MutationTypes, useStore } from '@/store'
import Screen from './views/Screen/index.vue'
import { TemplateService } from './api/template'
import { UserService } from './api/user'
import useHistorySnapshot from './hooks/useHistorySnapshot'
import router from './router'
export default defineComponent({
  name: 'app',
  components: {
    Screen,
  },
  setup() {
    const store = useStore()
    const screening = computed(() => store.state.screening)
    const { save} = useHistorySnapshot()
    const getUserinfo = async () => {
      const params = {}
      const res = await UserService.sessionInfo(params)
      if (res) {
        store.commit(MutationTypes.SET_USER_INFO, res.data.data)
        // setCookie('userid', res.data.data.userid,7)
      }
      
    }
    getUserinfo()
    const getPublishList = async () => {
      try {
        const params = {}
        const res = await TemplateService.getTemplateScreen(params)
        localStorage.setItem('template', JSON.stringify(res.data.data.categoryList))
      }
      catch (err) {
        // console.log(err)
      }
    }
    getPublishList()
    if (!localStorage.getItem('template')) {
      getPublishList()
    }

    onMounted(() => {
      store.commit(MutationTypes.SET_AVAILABLE_FONTS)
      store.commit(MutationTypes.SET_SEARCH_HISTORY)
      document.onkeydown = function(event) {
        // 判断 Ctrl+S
        if (event.ctrlKey === true && event.keyCode === 83) {
          event.preventDefault()
          if (!router.currentRoute.value.path.match('/editor')) return
          store.commit(MutationTypes.SAVE_SPINNING, true)
          save()
        }
      }
    })

    return {
      screening,
    }
  },
})
